(()=>{
  const goToReviews=(url,event)=>{
    if(event){
      event.preventDefault();
      event.stopPropagation();
    }

    const destination=new URL(url,window.location.origin);
    const sameProduct=destination.pathname===window.location.pathname;
    const target=document.querySelector('#ak-product-reviews');

    if(sameProduct&&target){
      target.scrollIntoView({behavior:'smooth',block:'start'});
      history.replaceState(null,'','#ak-product-reviews');
      return;
    }

    window.location.assign(destination.href);
  };

  const formatReviewTotal=value=>{
    const count=Number(String(value).replace(/,/g,''));
    if(!Number.isFinite(count)||count<1000)return String(value);
    const abbreviated=Math.round((count/1000)*10)/10;
    return `${abbreviated.toFixed(abbreviated%1===0?0:1)}K`;
  };

  /* Presentation-only: abbreviate genuine Ali Reviews totals (1,234 -> 1.2K).
     Never invents, inflates, or changes the underlying review count. */
  const formatAliReviewCounts=(scope=document)=>{
    const ratings=scope.querySelectorAll?.(
      '.alireviews-review-star-rating, .ak-pdp-app-rating, #ak-product-reviews .alireviews-review-box'
    );

    ratings?.forEach(rating=>{
      const walker=document.createTreeWalker(rating,NodeFilter.SHOW_TEXT);
      const textNodes=[];
      while(walker.nextNode())textNodes.push(walker.currentNode);

      textNodes.forEach(node=>{
        const original=node.nodeValue||'';
        if(!original.trim())return;

        const formatted=original.replace(
          /(\(?\s*)(\d{1,3}(?:,\d{3})+|\d{4,})(\s*(?:reviews?|ratings?)\s*\)?)/gi,
          (match,prefix,count,suffix)=>`${prefix}${formatReviewTotal(count)}${suffix}`
        );

        if(formatted!==original)node.nodeValue=formatted;
      });
    });
  };

  const forceHeroReviewTextWhite=(scope=document)=>{
    const ratings=scope.querySelectorAll?.('.ak-home .ak-hero-detail .alireviews-review-star-rating');
    ratings?.forEach(rating=>{
      const walker=document.createTreeWalker(rating,NodeFilter.SHOW_TEXT);
      const textNodes=[];
      while(walker.nextNode())textNodes.push(walker.currentNode);

      textNodes.forEach(node=>{
        const text=node.nodeValue||'';
        const trimmed=text.trim();
        if(!trimmed)return;
        /* Leave star glyphs orange; force every other visible character in this top hero rating row white. */
        if(/^[★☆⭐✦✧\s]+$/u.test(trimmed))return;
        const parent=node.parentElement;
        if(parent?.classList.contains('ak-review-text-force-white'))return;

        const span=document.createElement('span');
        span.className='ak-review-text-force-white';
        span.textContent=text;
        node.replaceWith(span);
      });
    });
  };

  let reviewRenderQueued=false;
  const refreshReviewPresentation=(scope=document)=>{
    if(reviewRenderQueued)return;
    reviewRenderQueued=true;
    requestAnimationFrame(()=>{
      reviewRenderQueued=false;
      formatAliReviewCounts(scope);
      forceHeroReviewTextWhite(scope);
    });
  };

  const initReviewPresentation=()=>{
    refreshReviewPresentation(document);

    if('MutationObserver' in window){
      new MutationObserver(mutations=>{
        const relevant=mutations.some(mutation=>{
          const target=mutation.target?.nodeType===1?mutation.target:mutation.target?.parentElement;
          return target?.closest?.(
            '.alireviews-review-star-rating, .ak-pdp-app-rating, #ak-product-reviews, .ak-home .ak-hero-detail-wrap'
          );
        });
        if(relevant)refreshReviewPresentation(document);
      }).observe(document.body,{childList:true,subtree:true,characterData:true});
    }
  };

  document.addEventListener('click',event=>{
    const pdpRating=event.target.closest?.('.ak-pdp-app-rating');
    if(pdpRating&&document.querySelector('#ak-product-reviews')){
      goToReviews('#ak-product-reviews',event);
      return;
    }

    const embedded=event.target.closest?.('[data-ak-review-url]');
    if(embedded){
      goToReviews(embedded.dataset.akReviewUrl,event);
      return;
    }

    const link=event.target.closest?.('a.ak-ali-rating-link[href*="#ak-product-reviews"]');
    if(!link)return;
    const destination=new URL(link.href,window.location.origin);
    if(destination.pathname===window.location.pathname&&document.querySelector('#ak-product-reviews')){
      goToReviews(link.href,event);
    }
  });

  document.addEventListener('keydown',event=>{
    if(event.key!=='Enter'&&event.key!==' ')return;
    const embedded=event.target.closest?.('[data-ak-review-url]');
    if(embedded)goToReviews(embedded.dataset.akReviewUrl,event);
  });

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initReviewPresentation,{once:true});
  }else{
    initReviewPresentation();
  }

  document.addEventListener('shopify:section:load',()=>setTimeout(()=>refreshReviewPresentation(document),0));
  window.addEventListener('pageshow',()=>setTimeout(()=>refreshReviewPresentation(document),0));
})();
